var _path, _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeStart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66994 4.4601C2.46331 4.31626 2.41135 4.03117 2.56742 3.83363C3.44682 2.72063 4.62513 1.87616 5.96861 1.40209C7.45571 0.877335 9.07006 0.832916 10.5838 1.2751C12.0975 1.71728 13.4341 2.62373 14.4048 3.86648C15.3756 5.10923 15.9315 6.6255 15.9941 8.20122C16.0567 9.77695 15.6228 11.3325 14.7537 12.6484C13.8846 13.9642 12.6241 14.9738 11.1502 15.5347C9.67636 16.0955 8.06357 16.1793 6.53953 15.7742C5.16268 15.4082 3.9211 14.6598 2.95619 13.6201C2.78493 13.4356 2.81412 13.1473 3.00868 12.9875V12.9875C3.20324 12.8277 3.48939 12.8571 3.66218 13.0402C4.50474 13.9331 5.58155 14.5762 6.77375 14.8931C8.11319 15.2492 9.53063 15.1755 10.826 14.6826C12.1213 14.1897 13.2291 13.3023 13.993 12.1459C14.7568 10.9894 15.1382 9.62227 15.0832 8.23741C15.0281 6.85254 14.5396 5.51994 13.6864 4.42772C12.8332 3.3355 11.6585 2.53885 10.3281 2.15022C8.99777 1.7616 7.57896 1.80064 6.27198 2.26183C5.10867 2.67232 4.08627 3.3988 3.31719 4.35566C3.15947 4.55189 2.87656 4.60394 2.66994 4.4601V4.4601Z",
    fill: "#818181"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.01953,
    y: 3.43457,
    width: 0.907353,
    height: 5.63193,
    rx: 0.453677,
    fill: "#818181"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.83154,
    y: 8.61621,
    width: 0.907353,
    height: 5.51903,
    rx: 0.453677,
    transform: "rotate(-45 7.83154 8.61621)",
    fill: "#818181"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 8.05225,
    width: 6.13148,
    height: 0.905808,
    rx: 0.452904,
    fill: "#818181"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.47803,
    y: 5.84375,
    width: 3.90914,
    height: 0.905808,
    rx: 0.452904,
    transform: "rotate(42.9039 3.47803 5.84375)",
    fill: "#818181"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3.90914,
    height: 0.905808,
    rx: 0.452904,
    transform: "matrix(0.732496 -0.680771 -0.680771 -0.732496 3.45166 11.2358)",
    fill: "#818181"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeStart);
export default __webpack_public_path__ + "static/media/timeStart.6fae895c271f5d033e232677db19621b.svg";
export { ForwardRef as ReactComponent };